import * as types from './orderStatusActionTypes';

export const getOrderStatusRequestAction = (payload) => ({
  type: types.GET_ORDER_STATUS_REQUEST,
  payload,
});

export const getOrderStatusDataAction = (payload) => ({
  type: types.GET_ORDER_STATUS_DATA,
  payload,
});

export const getOrderStatusErrorAction = (payload) => ({
  type: types.GET_ORDER_STATUS_ERROR,
  payload,
});

export const sortOrderStatusHistorySortData = (payload) => ({
  type: types.SET_ORDER_HISTORY_SORT_DATA,
  payload,
});

export const sortingOrderStatusHistoryAction = (payload) => ({
  type: types.SORTING_ORDER_HISTORY_ACTION,
  payload,
});

export const createOrderStatusRequestAction = (payload) => ({
  type: types.CREATE_ORDER_STATUS_REQUEST,
  payload,
});

export const createOrderStatusDataAction = (payload) => ({
  type: types.CREATE_ORDER_STATUS_DATA,
  payload,
});

export const createOrderStatusErrorAction = (payload) => ({
  type: types.CREATE_ORDER_STATUS_ERROR,
  payload,
});

export const updateOrderStatusRequestAction = (payload) => ({
  type: types.UPDATE_ORDER_STATUS_REQUEST,
  payload,
});

export const updateOrderStatusDataAction = (payload) => ({
  type: types.UPDATE_ORDER_STATUS_DATA,
  payload,
});

export const updateOrderStatusErrorAction = (payload) => ({
  type: types.UPDATE_ORDER_STATUS_ERROR,
  payload,
});

export const deleteOrderStatusRequestAction = (payload) => ({
  type: types.DELETE_ORDER_STATUS_REQUEST,
  payload,
});

export const deleteOrderStatusDataAction = (payload) => ({
  type: types.DELETE_ORDER_STATUS_DATA,
  payload,
});

export const deleteOrderStatusErrorAction = (payload) => ({
  type: types.DELETE_ORDER_STATUS_ERROR,
  payload,
});